import BaseBall from './BaseBall.vue'

export default BaseBall
